const styles = {
  appBar: {
    backgroundColor: "#ffffff",
    height: 70,
    display: "flex",
    justifyContent: "center",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    color: "black",
  },
  logo: {
    height: 32,
    marginRight: 30,
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  headerElementIcon: {
    height: "50%",
  },
};

export default styles;
